/**
 * Secciones relacionadas por ruta: para mostrar al final de cada página
 * con enlace + icono a otras secciones.
 */
import AnyePote2 from '../Components/icons/AnyePote2';
import AnyeMosca2 from '../Components/icons/AnyeMosca2';
import AnyeMosquito2 from '../Components/icons/AnyeMosquito2';
import AnyeEsposas from '../Components/icons/AnyeEsposas';
import AnyeGrillete from '../Components/icons/AnyeGrillete';
import AnyeVistasBarco4 from '../Components/icons/AnyeVistasBarco4';
import AnyeVistasBarco1 from '../Components/icons/AnyeVistasBarco1';
import AnyeVistasBarco3 from '../Components/icons/AnyeVistasBarco3';
import AnyeCandado from '../Components/icons/AnyeCandado';

const gispertSections = [
  { to: '/Gispert1', labelKey: 'nav.gispert1', Icon: AnyeEsposas },
  { to: '/Gispert2', labelKey: 'nav.gispert2', Icon: AnyePote2 },
  { to: '/Gispert3', labelKey: 'nav.gispert3', Icon: AnyeGrillete },
  { to: '/Gispert4', labelKey: 'nav.gispert4', Icon: AnyeVistasBarco4 },
  { to: '/Gispert5', labelKey: 'nav.gispert5', Icon: AnyeMosquito2 },
  { to: '/Gispert6', labelKey: 'nav.gispert6', Icon: AnyeMosca2 },
];

const museoSections = [
  { to: '/Museo1', labelKey: 'nav.museo1', Icon: AnyeVistasBarco1 },
  { to: '/Museo2', labelKey: 'nav.museo2', Icon: AnyeVistasBarco3 },
];

const instructivoItem = { to: '/Instructivo', labelKey: 'nav.instructivo', Icon: AnyeCandado };

/** Para cada página Gispert: las otras 5 Gispert + Instructivo (excluir la actual) */
export function getRelatedSectionsForGispert(currentPath) {
  const others = gispertSections.filter((s) => s.to !== currentPath);
  return [...others, instructivoItem];
}

/** Para Museo1: Museo2 + Instructivo. Para Museo2: Museo1 + Instructivo */
export function getRelatedSectionsForMuseo(currentPath) {
  const others = museoSections.filter((s) => s.to !== currentPath);
  return [...others, instructivoItem];
}
